import { ApiHelper } from 'shared/api';
import { ROUTES, getSeoUrl, getUrl } from 'shared/api/urls';
import { transformTruecallerStatus } from './transformer';
import { queryStringFromParams } from 'shared/helpers/utils/url';
import { logger } from 'shared/logging';
import { ERROR_FETCHING_BREADCRUMBS } from './constants';

const CREDENTIAL = 'credential';

export const getOneTapData = async (params: any) => {
  const { credential, state } = params;
  const url = getUrl(ROUTES.ONE_TAP);
  const queryString = queryStringFromParams({ state });
  const formData = new FormData();
  formData.append(CREDENTIAL, credential);
  try {
    const data = await ApiHelper(`${url}${queryString}`, 'POST', formData);
    return data;
  } catch (e) {
    logger.error(e, `Error fetching one tapData: url=${url}`);
    throw e;
  }
};

export const getRequestId = async () => {
  const queryParams = {
    domain: __PLATFORM__,
    platform: 'WEB',
    user_version: 'v2',
  };

  const url = '/gateway-api/truecaller/v1/initiate';
  try {
    const { data: response } = await ApiHelper(`${url}`, 'post', queryParams);
    const { response: data } = response || {};
    return data?.requestId;
  } catch (e) {
    logger.error(e, `Error fetching truecallerId: url=${url}`);
    throw e;
  }
};

interface TruecallerProps {
  requestId: string;
}

export const getTrueCallerStatus = async (requestParams: TruecallerProps) => {
  const url = '/gateway-api/truecaller/v1/status';
  try {
    const { data: response } = await ApiHelper(`${url}`, 'post', requestParams);
    return transformTruecallerStatus(response);
  } catch (e) {
    logger.error(e, `Error fetching truecallerStatus: url=${url}`);
    throw e;
  }
};

export const getBreadcrumbs = async (id: string) => {
  const url = getSeoUrl(ROUTES.BREADCRUMBS);
  logger.info(`Fetching breadcrumbs for url: ${url}`);
  const domain = process.env.PLATFORM;
  try {
    const { data } = await ApiHelper(`${url}?id=${id}&domain=${domain}`, 'get');
    logger.info(`Response received breadcrumbs with id=${id}`);
    return data?.response;
  } catch (error) {
    logger.error(error, ERROR_FETCHING_BREADCRUMBS);
    return null;
  }
};

export const getBreadcrumbsWithTimeout = async (
  id: string,
  timeout: number = 100
): Promise<any> =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(
        new Error(
          `Request timed out for breadcrumbs with id=${id} and timeout=${timeout}`
        )
      );
    }, timeout);

    getBreadcrumbs(id)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
